<template>
    <v-main>
        <v-container
            class="fill-height"
            fluid
        >
            <v-row
                align="center"
                justify="center"
            >
                <v-col
                    cols="12"
                    sm="8"
                    md="4"
                >
                    <v-card class="elevation-12">
                        <v-toolbar
                            :color="groupSetting.mainColor"
                            dark
                            flat
                        >
                            <v-img
                                    alt="Vuetify Logo"
                                    class="shrink mr-2"
                                    contain
                                    :src="groupSetting.logoUrl"
                                    transition="scale-transition"
                                    :width="groupSetting.logoSize"
                            />
                            <v-toolbar-title>{{ groupSetting.groupName }} 로그인</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-icon>mdi-login</v-icon>
                        </v-toolbar>
                        <v-card-text>
                            <v-form>
                                <v-text-field
                                        label="로그인"
                                        name="login"
                                        prepend-icon="mdi-account"
                                        type="text"
                                        v-model="userCredentials.userId"
                                        @keyup="moveFocus"
                                        ref="userId"
                                ></v-text-field>

                                <v-text-field
                                        id="password"
                                        label="패스워드"
                                        name="password"
                                        prepend-icon="mdi-lock"
                                        type="password"
                                        v-model="userCredentials.password"
                                        @keyup="getSignedIn"
                                        ref="password"
                                ></v-text-field>
                            </v-form>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn :color="groupSetting.mainColor" v-on:click="getSignedIn">로그인</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </v-main>
</template>

<script>
import router from "@/router";

export default {
    name: 'UserLogin',
    data() {
        return {
            userCredentials: {
                userId: "",
                password: ""
            },
            groupSetting: {
                mainColor: 'primary',
                groupName: '로딩중',
                logoUrl: 'https://www.google.com/logos/doodles/2020/december-holidays-days-2-30-6753651837108830.3-law.gif',
                faviconUrl: 'https://www.google.com/logos/doodles/2020/december-holidays-days-2-30-6753651837108830.3-law.gif'
            }
        }
    },
    methods: {
        getSignedIn: function(e) {
            if(e.keyCode == 13 || e.type == 'click'){
                this.$rollbar.warning('로그인 실패', e)
                this.$store.dispatch('getSignedIn', this.userCredentials)
            }
        },
        moveFocus: function(e) {
            if(e.keyCode == 13){
                this.$refs.password.focus()
            }
        }
    },
    beforeCreate: function() {

        if(this.$store.getters.getAccessToken){
            router.push('/dashboard')
            return false
        }

    },
    created: function() {
        this.groupSetting = this.$store.getters.getGroupSetting
        // if(this.$store.getters.getGroupSetting != null){
        // }
    },
    mounted: function() {
        this.$refs.userId.focus()
    }
}
</script>

<style>

</style>